// extracted by mini-css-extract-plugin
module.exports = {"container":"FailPay_container__1144U","logo":"FailPay_logo__2Bx-7","text":"FailPay_text__GZ-go","icon":"FailPay_icon__3w5AW"};